<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card card-w-title">
                <div class="manager-title" v-text="title"></div>
                <div class="row">
                    <div class="col-lg-6" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                        <label class="bold required">Công ty</label>
                        <DropdownScrollable :showClear="false" width="100%" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent"/>
                    </div>
                    <div class="col-lg-3">
                        <label class="bold required">Thời gian</label>
                        <div style=" margin: 10px 0;">
                            <Calendar style="width: 100%" v-model="year" view="year" dateFormat="yy" appendTo="body" :showIcon="true"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <chartArea :areas.sync="areas" :loading="chartLoading.areas"/>
                    <chartResult :evaluation_form.sync="evaluation_form" :loading="chartLoading.evaluation_form"/>
                    <chartProject :project.sync="project" :loading="chartLoading.project"/>
                    <chartCategory :category.sync="category" :loading="chartLoading.category"/>
                    <categoryBox :category.sync="category" :category_old.sync="category_old" :loading="chartLoading.category"/>
                    <chartCriteria :criteria.sync="criteria" :criteria_old_old.sync="criteria_old_old" :criteria_old.sync="criteria_old" :lables.sync="lables" :loading="chartLoading.criteria"/>
                    <chartBpks :bpks.sync="bpks" :loading="chartLoading.bpks"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import Calendar from '@/components/Calendar.vue';
import chartArea from "./charts/chartArea.vue";
import chartResult from "./charts/chartResult.vue";
import chartProject from "./charts/chartProject.vue"; 
import chartCategory from "./charts/chartCategory.vue";
import categoryBox from "./charts/categoryBox.vue";
import chartCriteria from "./charts/chartCriteria.vue";
import chartBpks from "./charts/chartBpks.vue";
export default {
    components: {
        DropdownScrollable,
        Calendar,
        chartArea,
        chartResult,
        chartProject,
        chartCategory,
        categoryBox,
        chartCriteria,
        chartBpks
    },
    data() {
        return {
            filters : {},
            filterOptions: {},
            options: [],
            listData: [],
            title: "Dashboard",
            year: new Date(),
            yearRange: `${this.year-100}:${this.year+100}`,
            componentKey: 0,
            company: {},
            company_obj: {
                offset: 0,
                filters: {},
                limit: 20,
                items: [],
                total: 0,
                loading: false
            },
            evaluation_form: {},
            project: {},
            areas: {},
            criteria: {},
            criteria_old: {},
            criteria_old_old: {},
            lables: [],
            category: {},
            category_old: {},
            bpks: {},
            chartLoading: {
                evaluation_form: false,
                areas: true,
                criteria: false,
                category: false,
                bpks: false,
                project: false,
            }
        }
    },
    async created() {
        if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
            await this.getListCompany();
        }
        if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
            if (this.company?.id != this.$store.getters?.company_id) {
                this.$set(this,'company', {id: this.$store.getters?.company_id});
            }
        }
    },
    watch: {
        'company'() {
            this.loadEvaluationFormData();
            this.loadProjectData();
            this.loadAreaData();
            this.loadBpksData();
            this.loadCriteriaData();
            this.loadCategoryData();
        },
        "year"() {
            this.loadEvaluationFormData();
            this.loadProjectData();
            this.loadAreaData();
            this.loadBpksData();
            this.loadCriteriaData();
            this.loadCategoryData();
        }
    },
    methods: {
        emitEvent(keyword) {
            this.$delete(this.company_obj.filters, 'name');
            if (keyword) {
                this.company_obj.filters.name = keyword;
            }
            this.getListCompany();
        },
        async getListCompany() {
            var token = this.$store.getters.token ? this.$store.getters.token : null
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                this.company_obj.loading = true;
                await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
                    if (this.offset > 0) {
                    this.company_obj.items.push(...res.data.data.company);
                    } else {
                    this.company_obj.items = res.data.data.company;
                    }
                    this.company_obj.total = res.data.data.total;
                    this.company_obj.loading = false;
                    if (this.company_obj.items.length > 0) {
                        this.company = this.company_obj.items[0];
                    }
                }).catch((err) => {
                    console.log(err);
                    this.company_obj.loading = false;
                })
            }
        },
        async loadProjectData() {
            this.chartLoading.project = true;
            var token = this.$store.getters.token ? this.$store.getters.token : null
            this.project = {};
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_project", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.project = res.data.data?.project ?? {};
                    this.chartLoading.project = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.project = false;
                })
            }
        },
        async loadEvaluationFormData() {
            this.chartLoading.evaluation_form = true;
            var token = this.$store.getters.token ? this.$store.getters.token : null
            this.evaluation_form = {};
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_evaluation_form", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.evaluation_form = res.data.data?.evaluation_form ?? {};
                    this.chartLoading.evaluation_form = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.evaluation_form = false;
                })
            }
        },
        async loadAreaData() {
            this.chartLoading.areas = true;
            var token = this.$store.getters.token ? this.$store.getters.token : null
            this.areas = {};
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_area", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.areas = res.data.data?.area ?? {};
                    this.chartLoading.areas = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.areas = false;
                })
            }
        },
        async loadBpksData() {
            this.chartLoading.bpks = true;
            var token = this.$store.getters.token ? this.$store.getters.token : null
            this.bpks = {};
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_bpks", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.bpks = res.data.data?.bpks ?? {};
                    this.chartLoading.bpks = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.bpks = false;
                })
            }
        },
        async loadCriteriaData() {
            this.chartLoading.criteria = true;
            var token = this.$store.getters.token ? this.$store.getters.token : null
            this.criteria = {};
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_criteria", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.criteria = res.data.data?.criteria ?? {};
                    this.lables = res.data.data?.lables ?? [];
                    this.criteria_old = res.data.data?.criteria_old ?? {};
                    this.criteria_old_old = res.data.data?.criteria_old_old ?? {};
                    this.chartLoading.criteria = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.criteria = false;
                })
            }
        },
        async loadCategoryData() {
            this.chartLoading.category = true;
            this.category = {};
            var token = this.$store.getters.token ? this.$store.getters.token : null
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                
                await ApiRepository.post("/_api/dashboard/chart_category", {filters: {year: this.year.getFullYear()}, company_id: this.company.id}, {headers}).then((res) => {
                    this.category = res.data.data?.category ?? {};
                    this.category_old = res.data.data?.old_category ?? {};
                    this.chartLoading.category = false;
                }).catch((err) => {
                    console.log(err);
                    this.chartLoading.category = false;
                })
            }
        }
    }

}
</script>
<style>
.dashboard-box {
    background-color: #e0f0f8;
    padding: 10px 15px;
    border-radius: 5px;
    min-height: 50px;
    .success {
        color: #E97131 !important;
        font-size: 20px;
        font-weight: bolder;
    }
    .total {
        color: #146082 !important;
        font-size: 20px;
        font-weight: bolder;
    }
    .d-flex.justify-content-between {
        color: #333333;
    }
}
.p-chart {
    border: .75px solid #D9D9D9;
    padding: 10px;
    canvas {
        max-height: 250px !important;
    }
}
.chart-loading:before {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: #000000;
    opacity: .5;
    content: "Đang tải...";
    color: #ffffff;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}
</style>